export default __webpack_public_path__ + "static/media/diamonds.565ec517.png";